<script lang="ts" setup>
import Filter from "@/features/account/ui/filter.vue";
</script>

<template>
  <div class="v-contacts">
    <Filter  />
  </div>
</template>

<style lang="scss" scoped>
</style>